const drawArrowHead = function(context, params) {
	const x1 = params.x1;
	const x2 = params.x2;
	const y1 = params.y1;
	const y2 = params.y2;
	const isTransparent = params.isTransparent;

	const dx = x2 - x1;
	const dy = y2 - y1;
	const chordLength = Math.sqrt(dx * dx + dy * dy);
	const midX = (x1 + x2) / 2;
	const midY = (y1 + y2) / 2;

	const originX = midX + (params.length * dy) / chordLength;
	const originY = midY - (params.length * dx) / chordLength;

	context.beginPath();
	context.moveTo(originX, originY);
	context.lineTo(x1, y1);
	if (params.curved) {
		context.quadraticCurveTo(midX + dy / 2, midY - dx / 2, x2, y2);
	} else {
		context.lineTo(x2, y2);
	}
	context.closePath();
	if (!isTransparent) context.stroke();
	context.fill();
	return {
		endX: midX + (params.length * dy) / chordLength,
		endY: midY - (params.length * dx) / chordLength,
	};
};

const calculateArrowHeadPositions = function(params) {
	const startX = params.startX;
	const endX = params.endX;
	const startY = params.startY;
	const endY = params.endY;
	const headLength = params.headLength;
	const headHeight = params.headHeight;

	const dx = endX - startX;
	const dy = endY - startY;
	const fullLength = Math.sqrt(dx * dx + dy * dy);
	const midX = endX - (headLength / fullLength) * dx;
	const midY = endY - (headLength / fullLength) * dy;
	const x1 = midX + ((dy / fullLength) * headHeight) / 2;
	const x2 = midX - ((dy / fullLength) * headHeight) / 2;
	const y1 = midY - ((dx / fullLength) * headHeight) / 2;
	const y2 = midY + ((dx / fullLength) * headHeight) / 2;
	return {
		x1: x1,
		y1: y1,
		x2: x2,
		y2: y2,
		length: headLength,
		curved: !!params.curved,
		endX: endX,
		endY: endY,
	};
};

const drawFilledArrow = function(context, drawParams) {
	const {
		point,
		arrowHeadWidth,
		arrowHeadHeight,
		rectWidth,
		rectHeight,
		fill,
		flip = false,
	} = drawParams;

	let alpha = 1.0;
	if (fill.alpha || fill.alpha === 0.0) {
		alpha = fill.alpha;
	}
	const factor = flip ? -1 : 1;

	const arrowHeadHalfWidth = arrowHeadWidth / 2;
	const arrowHeadVerticalOffset = arrowHeadHeight || arrowHeadHalfWidth;

	const arrowLeftCorner = {
		x: point.x - arrowHeadHalfWidth,
		y: point.y + factor * arrowHeadVerticalOffset,
	};

	const arrowRightCorner = {
		x: point.x + arrowHeadHalfWidth,
		y: point.y + factor * arrowHeadVerticalOffset,
	};

	context.save();
	context.fillStyle = fill.color;
	context.globalAlpha = alpha;

	const arrowHeadProtrusion = (arrowHeadWidth - rectWidth) / 2;

	context.beginPath();
	context.moveTo(point.x, point.y); // Drawing tip of arrow
	context.lineTo(arrowLeftCorner.x, arrowLeftCorner.y); // Left corner of arrow triangle
	context.lineTo(arrowLeftCorner.x + arrowHeadProtrusion, arrowLeftCorner.y); // Top-left corner of bottom rect
	context.lineTo(
		arrowLeftCorner.x + arrowHeadProtrusion,
		arrowLeftCorner.y + factor * rectHeight
	); // Top-right corner of bottom rect
	context.lineTo(
		arrowRightCorner.x - arrowHeadProtrusion,
		arrowRightCorner.y + factor * rectHeight
	); // Bottom-right corner
	context.lineTo(arrowRightCorner.x - arrowHeadProtrusion, arrowRightCorner.y); // Bottom-left corner
	context.lineTo(arrowRightCorner.x, arrowRightCorner.y); // Right corner of arrow triangle
	context.lineTo(point.x, point.y);
	context.fill();

	context.restore();
};

const drawArrow = function(context, params) {
	let startX = params.x1;
	let startY = params.y1;
	const endX = params.x2;
	const endY = params.y2;
	const lineWidth = params.lineWidth;
	const headHeight = params.headHeight;
	const headLength = params.headLength;
	const headCurved = params.headCurved;
	const curvedArrow = params.curvedArrow;
	const dashed = params.dashed;
	const isTransparent = params.isTransparent;

	context.save();
	//drawing the arrow's line
	const oldLineWidth = context.lineWidth;
	if (lineWidth) {
		context.lineWidth = lineWidth;
	}
	if (dashed) {
		context.setLineDash([lineWidth * 6, lineWidth * 3]);
	}
	context.beginPath();
	context.moveTo(startX, startY);
	if (curvedArrow) {
		const dx = endX - startX;
		const dy = endY - startY;
		const midptX = (startX + endX) / 2;
		const midptY = (startY + endY) / 2;
		context.quadraticCurveTo(midptX + dy / 4, midptY - dx / 4, endX, endY);
		startX = midptX + dy / 4; // sets so the arrow head will be drawn pointing along the curve more or less
		startY = midptY - dx / 4.25; // same (the +0.25 adjusts so the arrowhead looks right with the curve)
	}

	const arrowHeadParams = calculateArrowHeadPositions({
		startX,
		endX,
		startY,
		endY,
		headLength,
		headHeight,
		curvedArrow,
	});

	if (!curvedArrow) {
		const x1 = arrowHeadParams.x1;
		const x2 = arrowHeadParams.x2;
		const y1 = arrowHeadParams.y1;
		const y2 = arrowHeadParams.y2;
		if (isTransparent) {
			context.lineTo((x1 + x2) / 2, (y1 + y2) / 2);
		} else {
			const midX = (x1 + x2) / 2;
			const midY = (y1 + y2) / 2;
			context.lineTo((midX + endX) / 2, (midY + endY) / 2);
		}
	}

	context.stroke();
	context.setLineDash([]);
	context.lineWidth = oldLineWidth;

	//drawing the arrow's head
	arrowHeadParams.curved = headCurved;
	arrowHeadParams.curvedArrow = curvedArrow;
	arrowHeadParams.isTransparent = isTransparent;
	drawArrowHead(context, arrowHeadParams);

	context.restore();
};

const drawStrokeArrow = function(context, params) {
	let startX = params.x1;
	let startY = params.y1;
	const endX = params.x2;
	const endY = params.y2;
	const lineWidth = params.lineWidth;
	const headHeight = params.headHeight;
	const headLength = params.headLength;
	const curvedArrow = params.curvedArrow;
	const dashed = params.dashed;
	const doNotStroke = params.doNotStroke;

	if (!params.continuePath) {
		context.beginPath();
	}
	context.save();
	//drawing the arrow's line
	const oldLineWidth = context.lineWidth;
	if (lineWidth) {
		context.lineWidth = lineWidth;
	}
	if (dashed) {
		context.setLineDash([lineWidth * 6, lineWidth * 3]);
	}

	context.moveTo(startX, startY);

	if (curvedArrow) {
		const dx = endX - startX;
		const dy = endY - startY;
		const midptX = (startX + endX) / 2;
		const midptY = (startY + endY) / 2;
		context.quadraticCurveTo(midptX + dy / 4, midptY - dx / 4, endX, endY);
		startX = midptX + dy / 4; // sets so the arrow head will be drawn pointing along the curve more or less
		startY = midptY - dx / 4.25; // same (the +0.25 adjusts so the arrowhead looks right with the curve)
	}

	const arrowHeadParams = calculateArrowHeadPositions({
		startX,
		endX,
		startY,
		endY,
		headLength,
		headHeight,
		curvedArrow,
	});

	if (!curvedArrow) {
		context.lineTo(endX, endY);
	}

	context.setLineDash([]);

	const {x1, y1, x2, y2} = arrowHeadParams;
	//drawing the arrow's head
	context.moveTo(x1, y1);
	context.lineTo(endX, endY);
	context.lineTo(x2, y2);

	if (!doNotStroke) {
		context.stroke();
	}
	context.lineWidth = oldLineWidth;
	context.restore();
};

const getArrowheadPoint = function(
	centerX,
	centerY,
	angle,
	radiusFromCenter,
	arrowHeadHalfWidth,
	isCCW
) {
	/**
	 *    *                   ---
	 *    *   *                |
	 *    *       *            | arrowHeadHalfWidth
	 *    *           *        |
	 *    *   (cX, cY) -> *   ---
	 *    *           *
	 *    *       *
	 *    *   *
	 *    *
	 */
	if (angle === "north") {
		return [
			centerX + arrowHeadHalfWidth * (isCCW ? -1 : 1),
			centerY - radiusFromCenter,
		];
	} else if (angle === "east") {
		return [
			centerX + radiusFromCenter,
			centerY - arrowHeadHalfWidth * (isCCW ? 1 : -1),
		];
	} else if (angle === "south") {
		return [
			centerX - arrowHeadHalfWidth * (isCCW ? -1 : 1),
			centerY + radiusFromCenter,
		];
	} else {
		return [
			centerX - radiusFromCenter,
			centerY + arrowHeadHalfWidth * (isCCW ? 1 : -1),
		];
	}
};

const getArrowheadPoints = function(
	centerX,
	centerY,
	angle,
	radiusFromCenter,
	isCCW,
	fontSize
) {
	const alpha = 0.3;
	const arrowHeadHalfWidth = fontSize * alpha;

	const arrowHeadPt = getArrowheadPoint(
		centerX,
		centerY,
		angle,
		radiusFromCenter,
		arrowHeadHalfWidth,
		isCCW
	);
	const [aX, aY] = arrowHeadPt;

	let xDirs = [1, 1],
		yDirs = [1, 1];

	if (angle === "north") {
		xDirs = isCCW ? [1, 1] : [-1, -1];
		yDirs = [1, -1];
	} else if (angle === "east") {
		xDirs = [1, -1];
		yDirs = isCCW ? [1, 1] : [-1, -1];
	} else if (angle === "south") {
		xDirs = isCCW ? [-1, -1] : [1, 1];
		yDirs = [1, -1];
	} else {
		xDirs = [1, -1];
		yDirs = isCCW ? [-1, -1] : [1, 1];
	}

	const arrowHeadTL = [
		aX + arrowHeadHalfWidth * xDirs[0],
		aY + arrowHeadHalfWidth * yDirs[0],
	];
	const arrowHeadBL = [
		aX + arrowHeadHalfWidth * xDirs[1],
		aY + arrowHeadHalfWidth * yDirs[1],
	];

	return [arrowHeadPt, arrowHeadTL, arrowHeadBL];
};

const drawRotationArrow = function(context, params) {
	const {
		centerX,
		centerY,
		startAngle,
		endAngle,
		end,
		radiusFromCenter,
		isCCW,
		fontSize,
		lineWidth,
		strokeStyle,
		fillStyle,
	} = params;

	const headPoints = getArrowheadPoints(
		centerX,
		centerY,
		end,
		radiusFromCenter,
		isCCW,
		fontSize
	);

	context.save();
	context.strokeStyle = strokeStyle;
	context.lineWidth = lineWidth;
	context.beginPath();
	context.arc(centerX, centerY, radiusFromCenter, startAngle, endAngle, isCCW);
	context.stroke();
	context.fillStyle = fillStyle;
	context
		.bp()
		.M(...headPoints[0])
		.L(...headPoints[1])
		.L(...headPoints[2])
		.fill();
	context.restore();
};

module.exports = {
	drawArrowHead,
	calculateArrowHeadPositions,
	drawArrow,
	drawStrokeArrow,
	drawFilledArrow,
	drawRotationArrow,
};
